import React, { useState, useEffect } from 'react';
import './ContactFormModal.css';

const ContactFormModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('submitting');
    
    try {
      const response = await fetch('https://formspree.io/f/mvgdobwd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        setFormStatus('success');
        setFormData({ name: '', email: '', message: '' });
        // Auto-close after 2 seconds
        setTimeout(() => {
          onClose();
          setFormStatus('idle');
        }, 2000);
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setFormStatus('error');
    }
  };
  
  const handleClose = () => {
    onClose();
    setFormStatus('idle');
    setFormData({ name: '', email: '', message: '' });
  };
  
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps
  
  if (!isOpen) return null;
  
  return (
    <div className="contact-form-overlay" onClick={handleClose}>
      <div className="contact-form-modal" onClick={(e) => e.stopPropagation()}>
        <button 
          className="contact-form-close" 
          onClick={handleClose}
          aria-label="Close form"
        >
          ×
        </button>
        
        <h2 className="contact-form-title">Share Feedback</h2>
        <p className="contact-form-subtitle">
          Help us improve TaxMe for Belgian investors like you
        </p>
        
        {formStatus === 'success' ? (
          <div className="contact-form-success">
            <div className="success-icon">✓</div>
            <p>Thank you for your feedback!</p>
            <p className="success-subtext">We'll review it carefully.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder="Your name"
                disabled={formStatus === 'submitting'}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="your@email.com"
                disabled={formStatus === 'submitting'}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                required
                rows="6"
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                placeholder="Share your feedback, report bugs, or suggest features..."
                disabled={formStatus === 'submitting'}
              />
            </div>
            
            {formStatus === 'error' && (
              <div className="form-error">
                Something went wrong. Please try again or check back later.
              </div>
            )}
            
            <div className="form-footer">
              <p className="form-privacy-note">
                Your feedback is sent securely via Formspree. We don't store any form data locally.
              </p>
              <div className="form-buttons">
                <button 
                  type="button" 
                  onClick={handleClose}
                  className="button button-secondary"
                  disabled={formStatus === 'submitting'}
                >
                  Cancel
                </button>
                <button 
                  type="submit"
                  className="button button-primary"
                  disabled={formStatus === 'submitting'}
                >
                  {formStatus === 'submitting' ? 'Sending...' : 'Send Feedback'}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactFormModal;